import { useId } from 'react';

export function Checkbox({ label, hint, className = '', ...resto }) {
  const id = useId();
  return (
    <div className={`flex items-start gap-2 ${className}`}>
      <input id={id} type="checkbox"
        className="mt-0.5 h-5 w-5 shrink-0 rounded border-line accent-[rgb(var(--brand-500))]"
        {...resto} />
      <label htmlFor={id} className="text-sm text-ink">
        {label}
        {hint && <span className="block text-xs text-muted">{hint}</span>}
      </label>
    </div>
  );
}

export function Switch({ label, checked, onChange, disabled, hint }) {
  return (
    <label className="flex cursor-pointer items-start gap-3">
      <button
        type="button" role="switch" aria-checked={checked} disabled={disabled}
        onClick={() => onChange(!checked)}
        className={`relative mt-0.5 h-6 w-11 shrink-0 rounded-full transition-colors disabled:opacity-50
          ${checked ? 'bg-brand-600' : 'bg-line'}`}
      >
        <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-surface shadow transition-all
          ${checked ? 'left-[22px]' : 'left-0.5'}`} aria-hidden />
      </button>
      <span className="text-sm text-ink">
        {label}
        {hint && <span className="block text-xs text-muted">{hint}</span>}
      </span>
    </label>
  );
}

// Filtri rapidi: `aria-pressed` racconta lo stato anche senza vedere il colore.
export function FilterChip({ active, count, children, ...resto }) {
  return (
    <button
      type="button" aria-pressed={active}
      className={`inline-flex min-h-[36px] items-center gap-1.5 rounded-full border px-3 text-sm transition-colors
        ${active ? 'border-brand-500 bg-brand-50 font-medium text-brand-700' : 'border-line bg-surface text-muted hover:text-ink'}`}
      {...resto}
    >
      {children}
      {count != null && <span className="text-2xs tabular-nums opacity-70">{count}</span>}
    </button>
  );
}

export function Tabs({ tabs, value, onChange, label = 'Sezioni' }) {
  return (
    <div role="tablist" aria-label={label} className="flex gap-1 border-b border-line">
      {tabs.map(tab => (
        <button
          key={tab.value} role="tab" type="button"
          aria-selected={value === tab.value}
          onClick={() => onChange(tab.value)}
          className={`min-h-[44px] border-b-2 px-3 text-sm transition-colors
            ${value === tab.value
              ? 'border-brand-600 font-medium text-brand-700'
              : 'border-transparent text-muted hover:text-ink'}`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export function Pagination({ page, pageCount, total, onChange, etichetta = 'elementi' }) {
  if (pageCount <= 1) return <p className="text-xs text-muted">{total} {etichetta}</p>;
  return (
    <nav aria-label="Paginazione" className="flex flex-wrap items-center justify-between gap-2">
      <p className="text-xs text-muted">{total} {etichetta}</p>
      <div className="flex items-center gap-2">
        <button type="button" className="min-h-[36px] rounded border border-line px-3 text-sm disabled:opacity-50"
          disabled={page <= 1} onClick={() => onChange(page - 1)}>Precedente</button>
        <span className="text-sm tabular-nums text-muted" aria-live="polite">{page} di {pageCount}</span>
        <button type="button" className="min-h-[36px] rounded border border-line px-3 text-sm disabled:opacity-50"
          disabled={page >= pageCount} onClick={() => onChange(page + 1)}>Successiva</button>
      </div>
    </nav>
  );
}
